import { render } from "./PanelRedirect.vue?vue&type=template&id=5a73df66&scoped=true"
import script from "./PanelRedirect.vue?vue&type=script&lang=js"
export * from "./PanelRedirect.vue?vue&type=script&lang=js"

import "./PanelRedirect.vue?vue&type=style&index=0&id=5a73df66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a73df66"]])

export default __exports__